import { type ReactNode } from 'react';
import { type NavigationItem } from '@models/Navigation';
import s from '../../app-menu.module.scss';
import { LinkItem } from '../LinkItem/LinkItem';

export interface SubMenuProps {
    items: NavigationItem[];
    sidebarCollapsed?: boolean;
}

export function SubMenu({ items, sidebarCollapsed }: SubMenuProps): ReactNode {
    if (!items) {
        return;
    }

    return (
        <nav
            className={`${s.subNav} ${sidebarCollapsed ? s.subNavCollapsed : ''}`}
        >
            <ul>
                {items.map((item) => (
                    <LinkItem
                        key={item.label}
                        item={item}
                        exact={item.exact}
                        sidebarCollapsed={sidebarCollapsed}
                        isSubmenuItem
                    />
                ))}
            </ul>
        </nav>
    );
}
